var _ellipse, _path, _circle, _circle2, _path2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _circle9, _path9, _path10, _path11, _path12, _path13, _path14, _circle10, _path15, _path16;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 644,
    height: 673,
    viewBox: "0 0 644 673",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 204,
    cy: 659,
    rx: 204,
    ry: 14,
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M563.32919,507.09306c2.00214-11.24386,12.36631-17.85147,22.70027-20.49594,11.79488-3.01833,24.36762-2.64691,36.37126-1.28545,24.172,2.7416,47.9067,10.15049,72.43654,9.00179a122.02,122.02,0,0,0,59.952-19.29211,118.06766,118.06766,0,0,0,42.08853-47.17972,122.14528,122.14528,0,0,0,12.26974-62.508c-.20058-2.67954-.50547-5.34808-.88191-8.00835-.26939-1.90376-3.16047-1.09383-2.89284.79751a118.18678,118.18678,0,0,1-8.7215,63.08415,115.317,115.317,0,0,1-39.7375,48.78764,119.32347,119.32347,0,0,1-59.09643,21.14009c-24.21664,1.76836-47.74695-5.19221-71.54495-8.34524-12.01939-1.59247-24.27819-2.18575-36.27844-.0982-10.62971,1.84913-21.53507,6.603-26.99164,16.45091a23.16814,23.16814,0,0,0-2.56592,7.15339c-.33617,1.88789,2.55441,2.6981,2.89283.79752Z",
    transform: "translate(-278 -113.5)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 519,
    cy: 125,
    r: 125,
    fill: "#f39c12"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 472,
    cy: 100,
    r: 32,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M760.02637,277.5A19.02426,19.02426,0,0,0,779,295.5h52a19.02425,19.02425,0,0,0,18.97363-18Z",
    transform: "translate(-278 -113.5)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 110.5,
    r: 17,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 103.5,
    r: 4,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 100.5,
    r: 32,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 110.5,
    r: 17,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 103.5,
    r: 4,
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 521,
    cy: 136,
    r: 12,
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 517,
    y: 243,
    width: 22,
    height: 17,
    fill: "#f39c12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M501.26168,690.61909s14.11636,41.34079,8.06649,56.46547l18.14961,16.133,11.09144-14.11637s-12.09975-12.09974-11.09144-21.17455,2.01663-41.34079,2.01663-41.34079Z",
    transform: "translate(-278 -113.5)",
    fill: "#ffb9b9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M568.813,771.27852c-.82434.48191-1.6106.93843-2.33346,1.357H503.89548a3.303,3.303,0,0,1-1.62322-3.37337c.29165-1.49643,1.03983-4.54,1.96565-8.04015,2.1939-8.28117,5.415-19.124,6.11258-17.97a.01241.01241,0,0,1,.01261.0127c.97652,1.80085,2.99294,9.86638,8.04022,8.86448,5.04729-1.01452,13.1129-3.03086,13.1129-3.03086s-2.87877-6.46771-.12687-9.08013a3.857,3.857,0,0,1,2.14321-1.00182c6.04919-1.00183,6.04919,8.06553,6.04919,8.06553L561.762,759.18022a36.84237,36.84237,0,0,1,5.58,2.04173C571.84395,763.32708,576.29524,766.92871,568.813,771.27852Z",
    transform: "translate(-278 -113.5)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M460.9292,675.49441l-26.21611,31.25767-7.05818,16.133,9.0748,7.05818,8.0665-3.02493s7.05818-18.14962,14.11637-21.17455,24.19948-23.19117,24.19948-23.19117Z",
    transform: "translate(-278 -113.5)",
    fill: "#ffb9b9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M515.8822,651.50663,502.512,676.291l-9.579,17.74632c-3.06525,1.825-7.1489,1.79477-11.54518.71586a44.21718,44.21718,0,0,1-6.0095-2.00653c-11.99894-4.91047-24.16927-14.66083-24.16927-14.66083l23.02987-28.77726,7.522-9.38738,1.78473-2.23842,8.60093,3.6803,15.17508,6.48344Z",
    transform: "translate(-278 -113.5)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M456.21133,437.49154l-10.68016,43.80955,10.99342,56.205s.2708,22.976,10.345,21.23238-.48338-24.9159-.48338-24.9159l-4.92769-46.08507,15.755-45.52977c1.27621-3.68807-.33549-7.64731-4.032-9.905l0,0C466.9433,428.49276,458.07824,431.20339,456.21133,437.49154Z",
    transform: "translate(-278 -113.5)",
    fill: "#ffb9b9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M493.69934,399.72111l-9.07481,28.23273-17.1413-9.07481s7.05818-20.16623,7.05818-23.19117S493.69934,399.72111,493.69934,399.72111Z",
    transform: "translate(-278 -113.5)",
    fill: "#ffb9b9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.64115,
    cy: 276.13799,
    r: 21.17455,
    fill: "#ffb9b9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M492.18687,434.50787l-4.03325-4.03325-1.00831-5.04156s-13.10806-17.1413-24.19949-11.09143c-3.46607,1.89059-6.04593,6.24287-7.955,11.33366a55.05691,55.05691,0,0,0,1.26646,40.9528l17.77995,41.48655,40.33248-4.03325-7.05818-26.21611s7.05818-16.133-6.04987-27.22442Z",
    transform: "translate(-278 -113.5)",
    fill: "#f39c12"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M515.8822,651.50663,502.512,676.291l-9.579,17.74632c-3.06525,1.825-7.1489,1.79477-11.54518.71586-.76627-5.10205,3.81144-32.0643.21176-54.04549l.16131-.78651,1.78473-2.23842,8.60093,3.6803,15.17508,6.48344Z",
    transform: "translate(-278 -113.5)",
    opacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M515.8822,501.56061s-26.21611-16.133-44.36573,4.03325l1.00832,6.04987s-15.12468,17.1413-6.04987,53.44053,23.19117,131.08055,23.19117,131.08055,33.27429,2.01662,48.399-9.07481c0,0-5.04156-125.03068-22.18286-137.13042Z",
    transform: "translate(-278 -113.5)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M461.21607,445.40122l28.45,34.98484L541.09,505.59386s18.4693,13.66942,23.16831,4.5893-20.14338-14.67242-20.14338-14.67242L504.41958,471.586l-26.7537-40.06768c-2.16714-3.24562-6.2956-4.35423-10.32831-2.77346h0C460.53217,431.41246,457.33435,440.11365,461.21607,445.40122Z",
    transform: "translate(-278 -113.5)",
    fill: "#ffb9b9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M442.367,724.70314s6.18052-7.77305,9.87258-2.87546-4.35385,9.09468-4.35385,9.09468l-.46828,25.26389s4.3906,19.3175-7.46346,11.85405-12.32039-8.35744-14.65212-12.82738-7.15-22.42712-11.30836-28.2187-7.96656-17.45212-3.03027-18.88986,27.94543-6.55652,26.79913-4.85144-7.36553,7.22381-4.13981,11.2274S442.367,724.70314,442.367,724.70314Z",
    transform: "translate(-278 -113.5)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M497.73061,371.56549c.00007-.02585.002-.05127.002-.07712a29.241,29.241,0,1,0-29.241,29.24105c.6793,0,3.36551,5.08716,4.03325,5.04156C472.56485,390.33607,482.54938,372.6018,497.73061,371.56549Z",
    transform: "translate(-278 -113.5)",
    fill: "#2f2e41"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.23387,
    cy: 235.80551,
    r: 19.15793,
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M436.355,320.28451a19.13147,19.13147,0,0,1,5.46566,37.50068,19.14415,19.14415,0,1,0-5.46566-37.50068Z",
    transform: "translate(-278 -113.5)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M203.59959,251.9385H218.948a12.88435,12.88435,0,0,1,12.88435,12.88435v5.26526a0,0,0,0,1,0,0H203.59959a0,0,0,0,1,0,0V251.9385A0,0,0,0,1,203.59959,251.9385Z",
    fill: "#2f2e41"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.48cb6dcfe693ebe0705c5803dd17e9fb.svg";
export { ForwardRef as ReactComponent };